import { Text, Strong } from 'braid-design-system';
import dateFnsFormat from 'date-fns/format';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export interface MostRecentApplication {
  dateApplied: string;
  jobTitle: string;
  alreadyAppliedForThisPosition: boolean;
}

interface Props {
  mostRecentApplication: MostRecentApplication;
  firstName: string;
  lastName: string;
}

const PreviouslyAppliedMessage = ({
  firstName,
  lastName,
  mostRecentApplication,
}: Props) => {
  const capitalise = (str: string): string =>
    str.charAt(0).toUpperCase() + str.slice(1);
  const dateApplied = mostRecentApplication.dateApplied || '';
  const jobTitle = mostRecentApplication.jobTitle || '';
  const alreadyAppliedForThisPosition =
    mostRecentApplication.alreadyAppliedForThisPosition || false;
  const { t } = useTranslations(translations);

  if (Boolean(dateApplied) || Boolean(jobTitle)) {
    const formattedDate = dateFnsFormat(new Date(dateApplied), 'd MMM yy');
    const fullname = `${capitalise(firstName)} ${capitalise(lastName)}`;
    return (
      <Text>
        {alreadyAppliedForThisPosition
          ? t('Turns out fullname was a candidate for this...', {
              fullname,
              formattedDate,
              Strong: (children) => (
                <Strong key={`${children}`}>{children}</Strong>
              ),
            })
          : t('Turns out fullname was a candidate for the...', {
              fullname,
              jobTitle,
              formattedDate,
              Strong: (children) => (
                <Strong key={`${children}`}>{children}</Strong>
              ),
            })}
      </Text>
    );
  }
  return <></>;
};

export default PreviouslyAppliedMessage;
